@if (tokenService.isAuthenticated) {
  <div class="app-viewport">
    <div class="app-scale">
      <div class="app-screen">
        <router-outlet />
      </div>
    </div>
  </div>
} @else {
  <app-error
    [errorType]="tokenService.initState"
    [errorMessage]="tokenService.errorMessage" />
}
